import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCompany, acceptCompanyTOS } from "../actions/index";
import { Button } from "react-bootstrap";
import Terms from "./Terms";
import PropTypes from "prop-types";
import * as Constants from '../constants';

class TermsPage extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    acceptCompanyTOS: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showAgreeBtn: false
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      if (response.payload.data.data.latest_tos_accepted != true) {
        this.setState({ showAgreeBtn: true });
      }
    });
  }

  agree() {
    this.props
      .acceptCompanyTOS()
      .then(response => {
        if (response.payload.status == "200") {
          localStorage.setItem('agreedTOS', true);
          this.props
            .fetchCompany()
            .then(response => {
              if (response.payload.data.data.status != "enabled") {
                this.props.history.push(`/${response.payload.config.headers["X-Site-UUID"]}/status`);
              } else {
                this.props.history.push(`/${response.payload.config.headers["X-Site-UUID"]}/campaigns?${Constants.DEFAULT_PAGINATION}`);
              }
            });
        }
      });
  }

  render() {
    return (
      <div>
        <h1>Terms Of Service</h1>
        <Terms />
        <Button
          className={`btn btn-primary i_agree_btn ${
            this.state.showAgreeBtn ? "show" : "hide"
          }`}
          onClick={this.agree.bind(this)}
        >
          I Agree
        </Button>
        <Button
          className={`btn btn-default ${
            this.state.showAgreeBtn ? "hide" : "show"
          }`}
          onClick={this.agree.bind(this)}
        >
          Back
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany, acceptCompanyTOS }
)(TermsPage);
